var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMynextNft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "107.2px",
    height: "107.2px",
    viewBox: "0 0 107.2 107.2",
    style: {
      enableBackground: "new 0 0 107.2 107.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:none;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    className: "st0",
    d: "M0,0h107.2v107.2H0V0z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    x: 79,
    y: 85.8,
    className: "st0",
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 107.2,
    height: 107.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    className: "st2",
    d: "M32.8,18.8v6.4h-1.9v-5.9c0-1.5-0.9-2.4-2.2-2.2c-0.6,0.2-1.2,0.5-1.6,1c0,0.2,0,0.4,0,0.6v6.4 h-1.9v-5.8c0-1.5-0.9-2.4-2.2-2.2c-0.7,0.2-1.3,0.6-1.7,1.2l0,6.9h-1.9v-9.6l1.7-0.1l0.1,1.3c0.6-0.7,1.4-1.2,2.3-1.3 c1.3-0.2,2.5,0.5,3.1,1.6c0.6-0.9,1.5-1.5,2.5-1.6c1.7-0.2,3.3,1,3.5,2.8C32.8,18.4,32.8,18.6,32.8,18.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    className: "st2",
    d: "M43.4,15.5v9.9c0.2,2.2-1.5,4.2-3.7,4.3c-0.2,0-0.4,0-0.6,0c-1.2,0-2.4-0.5-3.2-1.4l0.9-1.3 c0.6,0.6,1.5,1,2.4,1c1.3,0,2.4-1,2.5-2.3c0-0.1,0-0.2,0-0.3v-1.5c-0.7,0.7-1.5,1.2-2.5,1.3c-1.7,0.2-3.2-1-3.5-2.7l0,0 c0-0.2,0-0.5,0-0.7v-6.2l1.9-0.1v5.7c0,1.7,0.9,2.5,2.2,2.2c0.8-0.2,1.5-0.8,1.9-1.5l0-6.4L43.4,15.5L43.4,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    className: "st2",
    d: "M60.1,18.8v6.4h-1.9v-5.9c0-1.5-0.9-2.4-2.2-2.2c-0.8,0.2-1.5,0.8-1.9,1.5v6.5h-1.9v-9.6 l1.8-0.1l0.1,1.6c0.6-0.9,1.5-1.4,2.5-1.6c1.7-0.2,3.3,1,3.5,2.8C60.1,18.4,60.1,18.6,60.1,18.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    className: "st2",
    d: "M71,20.9c0-0.3,0-0.5,0-0.8c0-2.6-1.6-4.7-4.2-4.7c-2.5,0-4.1,2.2-4.1,4.9c0,2.7,1.6,4.9,4.1,5 c1.8,0,3.4-1.1,4-2.8L69.2,22c-0.3,1-1.3,1.7-2.3,1.7c-1.4-0.1-2.4-1.2-2.4-2.6v-0.2L71,20.9L71,20.9z M66.8,17H67 c1.3,0,2.3,1.1,2.2,2.4v0h-4.7C64.5,18.1,65.5,17,66.8,17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    className: "st2",
    d: "M77.8,20.4l3.4,4.8h-2l-2.5-3.5l-2.4,3.5h-2l3.4-4.8l-3.4-4.8l2-0.1l2.5,3.6l2.5-3.6l2,0.1 L77.8,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    className: "st2",
    d: "M87.6,23.4v1.8c-0.3,0-0.5,0-0.7,0c-2,0-3-0.9-3-3.3v-4.4h-1.2v-1.8h1.2v-2.8l1.9-0.1v2.9h1.7 v1.8h-1.8v3.9c0,1.2,0.2,1.9,1.2,2C87.2,23.4,87.4,23.4,87.6,23.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.5,45.5v46h-5v-46h-8v-4.4h21v4.4H79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.4,67.8v23.6h-5V41h16.8v4.4H52.4v18h11.8v4.4L52.4,67.8L52.4,67.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 41.1,
    className: "st2",
    width: 5,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 41.1,
    className: "st2",
    width: 5,
    height: 50.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 71.5,
    className: "st2",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 76.5,
    className: "st2",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 81.5,
    className: "st2",
    width: 5,
    height: 5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMynextNft);
export default __webpack_public_path__ + "static/media/logoMynextNFT.ad5df3efb6e9b8dfbcf16b0d8257a34a.svg";
export { ForwardRef as ReactComponent };